import {CanActivateFn, Router} from '@angular/router';
import {inject} from "@angular/core";
import {arrayIsSet, GlobalVariablesService, Links} from "../service/global-variables.service";
import {filter, map, tap} from "rxjs/operators";
import {PermissionType, UserPermissionsParse} from "../../ParseClass/user-permissions-parse";

export const userAccessToPageGuard: CanActivateFn = (route, state) => {
    const globalVariable = inject(GlobalVariablesService)
    const router = inject(Router);
    let counter = 0

    if (globalVariable.currentProject == null) {
        router.navigate(['/project'])
        return false;
    }
    return globalVariable.permissionInProject$.pipe(
        filter(p => {
            counter++;
            return p != null || counter > 1
        }),
        map(pagePermissions => {
            const links = Links
            const path = route.url[0].path;
            const link = links.find(l => l.path == '/' + path)
            const obj = {isVerified: false, homePage: '/project'}
            const pageTypes = link?.pageType
            if (link == null || !arrayIsSet(pageTypes)) {
                obj.isVerified = true
            } else if (arrayIsSet(pagePermissions)) {
                const usersPermission = new UserPermissionsParse({})
                usersPermission.permissions = pagePermissions;
                const homePage = usersPermission.initialPageLink;
                obj.homePage = homePage;
                obj.isVerified = pagePermissions.some(uP => pageTypes.includes(uP.page!)
                    && [PermissionType.READ, PermissionType.EXEC, PermissionType.WRITE].includes(uP.permission!))
            }
            return obj
        }),
        tap(({isVerified, homePage}) => {
            if (!isVerified) {
                router.navigate([homePage])
            }
        }),
        map(isVerified => isVerified.isVerified),
    );
};
